import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { clearToken } from "@/lib/auth";
import { GlasstapeWordmark } from "@/components/ds";
import styles from "./login.module.sass";

export default function LoginPage() {
  const { loginWithRedirect, logout, isAuthenticated } = useAuth0();
  const location = useLocation();
  const from = (location.state as { from?: string })?.from || "/";

  useEffect(() => {
    clearToken();
    if (isAuthenticated) {
      logout({ logoutParams: { returnTo: `${window.location.origin}/login` } });
    }
  }, [isAuthenticated, logout]);

  return (
    <div className={styles.page}>
      <img
        className={styles.plate}
        src="/login.jpg"
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        decoding="async"
      />
      <div className={styles.scrim} aria-hidden="true" />
      <div className={styles.frame} aria-hidden="true" />

      <div className={styles.content}>
        <div className={styles.brand}>
          <GlasstapeWordmark size={32} />
        </div>

        <div className={styles.body}>
          <div className={styles.lede}>
            <h1 className={styles.title}>Sign in to your facilities.</h1>
            <p className={styles.sub}>
              The servicing layer for private credit lenders and the people who fund them.
            </p>
          </div>

          <button
            type="button"
            className={styles.continueBtn}
            onClick={() => loginWithRedirect({ appState: { returnTo: from } })}
          >
            Continue
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
        </div>

        <div className={styles.meta}>
          <span className={styles.metaLead}>Secure sign-in</span>
          <span className={styles.metaTrail}>Glasstape</span>
        </div>
      </div>
    </div>
  );
}
